import './product-carusel.less';

$(document).ready(function () {
    new Swiper('.product-carusel', {
        speed: 400,
        spaceBetween: 30,
        slidesPerView: 4,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
    });
});
